module.exports = __webpack_public_path__ + "img/white-video-not-fill.268a8d6d.svg";